import httpClient from "../../../shared/api/httpClient";

const InicioApi = {
  // devuelve { id, nombre, sucursales: [...] }
  getEmpresaById(empresaId) {
    if (!empresaId) throw new Error("empresaId requerido");
    return httpClient.get(`/empresas/${empresaId}`);
  },
};

export default InicioApi;
